function updateCountdown(timestamp) {
    const eventTime = timestamp * 1000;
    const now = new Date().getTime();
    const diff = eventTime - now;

    if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        document.querySelector('.days').textContent = String(days).padStart(2, '0');
        document.querySelector('.hours').textContent = String(hours).padStart(2, '0');
        document.querySelector('.minutes').textContent = String(minutes).padStart(2, '0');
    }
}

// The timestamp will be passed when initializing
document.addEventListener('DOMContentLoaded', function() {
    const countdownElement = document.querySelector('[data-countdown]');
    if (countdownElement) {
        const timestamp = countdownElement.dataset.countdown;
        updateCountdown(timestamp);
        setInterval(() => updateCountdown(timestamp), 60000); // Update every minute
    }
});